module.exports = __webpack_public_path__ + "img/trash-slash.702ff46d.svg";